import { useEffect, useState } from "react";
import PageShell from "@/components/PageShell";
import Seo from "@/components/Seo";
import { api } from "@/lib/api";

// Group results by month
const monthName = (key) => {
  // key = YYYYMMDD
  const y = key.slice(0, 4);
  const m = key.slice(4, 6);
  const names = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December",
  ];
  return `${names[parseInt(m, 10) - 1]} ${y}`;
};

export default function Historical() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    (async () => {
      const r = await api.get("/results?page=1&limit=500");
      setItems(r.data.items);
    })();
  }, []);

  const groups = items.reduce((acc, it) => {
    const key = it.date_key?.slice(0, 6) || "unknown";
    (acc[key] = acc[key] || []).push(it);
    return acc;
  }, {});
  const groupKeys = Object.keys(groups).sort().reverse();

  return (
    <>
      <Seo
        title="Historical Juwai Morning Teer Results by Month"
        description="Browse historical Juwai Morning Teer results grouped by month. Every entry displays the publish date, F/R and S/R numbers."
        path="/historical-results"
        breadcrumbs={[
          { name: "Home", path: "/" },
          { name: "Historical Results", path: "/historical-results" },
        ]}
      />
      <PageShell>
        <h1
          className="font-display text-3xl sm:text-4xl font-black tracking-tight text-emerald-950"
          data-testid="hist-h1"
        >
          Historical Results
        </h1>
        <p className="text-slate-600 mt-2 text-sm mb-6">
          Every published result, grouped by month. Historical data added here
          is limited to entries manually published by the admin.
        </p>

        {items.length === 0 && (
          <p className="text-slate-500 text-sm" data-testid="hist-empty">
            No historical data available yet.
          </p>
        )}

        {groupKeys.map((gk) => (
          <div key={gk} className="mb-8" data-testid={`hist-group-${gk}`}>
            <h2 className="font-display text-xl font-bold text-emerald-900 mb-3">
              {monthName(gk + "01")}
            </h2>
            <div className="rounded-2xl overflow-hidden border border-emerald-900/10 bg-white">
              <div className="grid grid-cols-[1.4fr_1fr_1fr] px-4 py-2 bg-emerald-950 text-white text-xs uppercase tracking-widest font-bold">
                <span>Date</span>
                <span className="text-center">F/R</span>
                <span className="text-center">S/R</span>
              </div>
              {groups[gk].map((it, i) => (
                <div
                  key={it.id}
                  className={`grid grid-cols-[1.4fr_1fr_1fr] px-4 py-2.5 items-center border-t border-emerald-900/5 ${
                    i % 2 ? "bg-emerald-50/40" : "bg-white"
                  }`}
                >
                  <span className="text-sm font-medium text-slate-800">
                    {it.date}
                  </span>
                  <span className="num-font text-center font-bold text-emerald-950">
                    {it.fr ?? "—"}
                  </span>
                  <span className="num-font text-center font-bold text-emerald-950">
                    {it.sr ?? "—"}
                  </span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </PageShell>
    </>
  );
}
